import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
`;

const NotFound = () => {
    return (
        <Container>
            페이지 없음!!!!
        </Container>
    );
};

export default React.memo(NotFound);